import axiosInstance from '../actions/AxiosInstance';
import api from '../actions/EndPoints';
import {
    commonErrorPromise,
    getAnalyticsActiveEngagement,
    getAnalyticsEngagementStatus,
    getAnalyticsEngagementType,
    getIsRasHH,
    setLastRequestTime,
} from '../Utils';
import { setMetricsDataStatus } from '../components/shared/Analytics';

/**
 * Makes a summary call to fetch consent data and update metrics
 * @param {string} apiKey - API key for authentication
 * @param {Function} dispatch - Dispatch function for user state updates
 */
export async function summaryCall(apiKey, dispatch) {
    await axiosInstance
        .get(api.newConsentAPI, {
            headers: {
                apikey: `${apiKey}`,
            },
        })
        .then((response) => {
            setLastRequestTime();
            const { planningGroup, engagementStatus } = response.data;
            const isRasHH = getIsRasHH(planningGroup, engagementStatus);
            const getEngagementStatuses = planningGroup?.activeEngagement?.engagementStatuses;
            const isCEInitiated = planningGroup?.activeEngagement?.initiatorType === 'REFERRAL_REP';
            const isAdvisorLed = !isCEInitiated && getEngagementStatuses?.some(
                (status) => status?.status === 'PRCN'
            );
            const getEngagementTypeCreation = () => {
                if (isAdvisorLed) {
                    return 'Advisor Initiated';
                } else if (isCEInitiated) {
                    return 'CE Initiated';
                } else {
                    return 'Online Initiated';
                }
            };
            const engagementTypeCreation = getEngagementTypeCreation();
            const analyticsClientType = 'client';
            const activeEngagement = getAnalyticsActiveEngagement(planningGroup);
            const status = response?.data?.planningGroup?.activeEngagement?.engagementStatus?.status;
            const effectiveDate = response?.data?.planningGroup?.activeEngagement?.effectiveDate;
            setMetricsDataStatus(
                isRasHH,
                analyticsClientType,
                getAnalyticsEngagementType(activeEngagement),
                null,
                getAnalyticsEngagementStatus(activeEngagement),
                engagementTypeCreation
            );
            dispatch({
                type: 'CLIENT_DATA',
                currentClientData: response?.data?.currentClient,
                planningGroup: response?.data?.planningGroup,
                engagementStatus: { status, effectiveDate }
            });
        })
        .catch((error) => {
            console.log(error);
            commonErrorPromise();
            throw error;

        });
}
